export const RouteToStepIndexMap = {
    "/configure":         0,
    "/configure/design":  1,
    "/configure/color":   2,
    "/configure/milieu":  3,
    "/configure/prewall": 4,
    "/configure/result":  5,
};


// WEBPACK FOOTER //
// ./src/app/core/maps.ts